import {EventEmitter, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import Compressor from 'compressorjs';

@Injectable({
  providedIn: 'root'
})
export class CompressImageService {

  constructor() { }

  public compress(blob: Blob): Observable<string | ArrayBuffer> {
    const emitter = new EventEmitter<string | ArrayBuffer>();
    const compressor = new Compressor(blob, {
      // strict: false,
      // mimeType: 'image/jpeg',
      quality: 0.8,
      convertSize: 50000,
      minWidth: 400,
      minHeight: 182,
      success(blobResult) {
        const reader = new FileReader();
        reader.readAsDataURL(blobResult);
        reader.onload = () => {
          const base64data =  reader.result;
          emitter.emit(base64data);
        };
      },
      error(err) {
        console.log(err.message);
      }
    });
    return emitter.asObservable();
  }
}
